// extracted by mini-css-extract-plugin
export default {"ringContainer":"animatedDot_ringContainer__ikQ7U","circle":"animatedDot_circle__O5meR","ring":"animatedDot_ring__LrYFI","pulsate":"animatedDot_pulsate__FwtDo"};